import { ActionTypes } from '../constans/action-types';

const initialState = {
  userData: {},
};

const userDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_USER_DETAILS:
      return {
        ...state,
        userData: action.data,
      };
    default:
      return state;
  }
};
export default userDataReducer;
